import useSWR, { SWRConfiguration } from 'swr';
import {
  ApiTokenType,
  MSLoginToken,
  MsLoginUrl,
  MsUnreadEmailCount,
  OutLookAttachment,
  OutlookScheduleDetail,
} from '@/types/api';
import {
  CALENDAR_LIST_URL,
  MS_AZURE_LOGIN_URL,
  MS_AZURE_TOKEN_URL,
  MS_AZURE_UNREAD_EMAIL_COUNT_URL,
} from '@/constant/apiList';
import { getNestedDataFetcher } from '@/utils/apis';
import process from 'process';
import { swrConfig } from '..';
import { msInstance } from '@/utils/api/msAzure/instance';

const REDIRECT_URL = `${process.env.NEXT_PUBLIC_ORIGIN_URL}/redirect`;

export const useMsLoginUrl = () => {
  return useSWR<MsLoginUrl>(
    `${MS_AZURE_LOGIN_URL}?redirectUri=${REDIRECT_URL}`,
    getNestedDataFetcher<MsLoginUrl>,
    swrConfig,
  );
};

/**
 * 로그인 화면을 거치지 않고 MS 재인증을 시작할 때 쓰는 명령형 버전.
 * SWR 훅으로 두면 인증이 멀쩡할 때도 매번 호출되므로, 클릭 시점에만 가져온다.
 */
export const fetchMsLoginUrl = () =>
  getNestedDataFetcher<MsLoginUrl>(
    `${MS_AZURE_LOGIN_URL}?redirectUri=${REDIRECT_URL}`,
  );

export const useMsLoginToken = (code?: string) => {
  return useSWR<MSLoginToken>(
    code
      ? `${MS_AZURE_TOKEN_URL}?code=${code}&redirectUri=${REDIRECT_URL}`
      : null,
    getNestedDataFetcher<MSLoginToken>,
    { ...swrConfig, revalidateOnFocus: false, revalidateOnReconnect: false },
  );
};

export const useMsUnreadEmailCount = (
  config: SWRConfiguration = {
    shouldRetryOnError: false, // 메일함이 없을 경우 에러가 발생하므로 재시도 방지
  },
) => {
  return useSWR<MsUnreadEmailCount>(
    MS_AZURE_UNREAD_EMAIL_COUNT_URL,
    (url: string) =>
      getNestedDataFetcher<MsUnreadEmailCount>(
        url,
        msInstance,
        ApiTokenType.MS,
      ),
    config,
  );
};

export const useGetOutlookDetail = (eventId: string) =>
  getNestedDataFetcher<OutlookScheduleDetail>(
    `${CALENDAR_LIST_URL}/${eventId}`,
    msInstance,
    ApiTokenType.MS,
  );

export const useGetOutlookAttachments = (eventId: string) =>
  getNestedDataFetcher<{ value: OutLookAttachment[] }>(
    `${CALENDAR_LIST_URL}/${eventId}/attachments`,
    msInstance,
    ApiTokenType.MS,
  );
